import MaterialIcons from "@expo/vector-icons/MaterialIcons";
import { Button, HStack, Icon, Image, Text, VStack } from "native-base";
import { InterfaceHStackProps } from "native-base/lib/typescript/components/primitives/Stack/HStack";
import React from "react";

import IfeiraLogo from "@/assets/icons/secondary_icon.png";
import AppStatusBar from "@/components/atoms/StatusBar";
import { useViewport } from "@/contexts/ViewportContext";

import BadgeList, { BadgeType } from "../BadgeList";

type MobileHeaderProps<T> = {
  title: string;
  subtitle?: string;
  showLogo?: boolean;
  showSearch?: boolean;
  badgeList?: T[];
  activeBadgeId?: string;
  onBackPress: () => void;
  onSelectBadge?: (item: T) => void;
  onPressSearch?: () => void;
} & InterfaceHStackProps;

const MobileHeader = <T extends BadgeType>({
  onBackPress,
  onSelectBadge,
  onPressSearch,
  subtitle,
  title,
  badgeList,
  showLogo = true,
  showSearch = false,
  activeBadgeId,
  ...props
}: MobileHeaderProps<T>) => {
  const { isWebMode } = useViewport();
  return (
    <VStack bgColor="white.50" shadow={isWebMode ? "none" : "4"}>
      {!isWebMode && <AppStatusBar />}
      <HStack p="2" h="72px" pr="4" justifyContent="space-between" alignItems="center" {...props}>
        <HStack flex={4 / 5} alignItems="center" space="2">
          <Button variant="ghost" onPress={() => onBackPress()}>
            <Icon as={<MaterialIcons name="arrow-back-ios" />} size="xl" color="primary.600" />
          </Button>
          <VStack flex={6 / 7}>
            <Text fontSize="lg" isTruncated bold>
              {title}
            </Text>
            {!!subtitle && (
              <Text fontSize="sm" isTruncated>
                {subtitle}
              </Text>
            )}
          </VStack>
        </HStack>
        <HStack flex={1 / 5} justifyContent="flex-end">
          {showLogo && (
            <Image source={IfeiraLogo} resizeMode="contain" w="80px" h="40px" alt="ifeira logo" />
          )}
          {showSearch && (
            <Button variant="ghost" onPress={() => onPressSearch()}>
              <Icon as={<MaterialIcons name="search" />} size="xl" color="primary.600" />
            </Button>
          )}
        </HStack>
      </HStack>
      {badgeList && (
        <HStack w="full" p="1" justifyContent="space-between" alignItems="center">
          <BadgeList
            list={badgeList}
            activeId={activeBadgeId}
            showsPassButons={false}
            onSelect={onSelectBadge}
          />
        </HStack>
      )}
    </VStack>
  );
};

export default MobileHeader;
